import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { ClientsFetchAPI } from '../../../api/Clients';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
import Select from 'react-select';
import Maps from '../../../utils/Maps';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const ModalCreateAddressClient = ({ modalcreateAddressClient, setModalcreateAddressClient, getAddressClientNow, client_id }) => {
    const [modalUserRegister, setModalUserRegister] = useState(false)
    const [nameDirection, setNameDirection] = useState('')
    const [numberHouse, setNumberHouse] = useState('')
    const [phone, setPhone] = useState('')
    const [additional_info, setadditional_info] = useState('')
    const [tables, setTables] = useState([]);
    const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });
    const [prefixPhone, setPrefixPhone] = useState('507');

    let token = localStorage.getItem("x-access-machine-token")

    const cleanInputs = () => {
        setNameDirection('')
        setNumberHouse('')
        setPhone('')
        setadditional_info('')
        setModalcreateAddressClient(false)
    }

    const createAddressClient = async () => {
        let data = {
            "name": nameDirection,
            "lat": coordinates.lat,
            "lng": coordinates.lng,
            "phone": phone,
            "house_num": numberHouse,
            "client_id": client_id,
            "additional_info": additional_info
        }

        console.log(data);
        try {
            const response = await ClientsFetchAPI.createAddressClient(data, token);
            console.log(response);
            ErrorAlert("", "Direccion creada correctamente", "success")
            getAddressClientNow()
            cleanInputs()

        } catch (err) {
            ErrorAlert("", "Error al crear la direccion del cliente", "error")
        }
    }







    return (
        <>
            <Modal
                show={modalcreateAddressClient}
                fullscreen
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='bg-blur-sp'
            >

                <Modal.Body>

                    <div className="d-flex justify-content-center border-bottom-0 m-3">
                        <h2 className="modal-title fw-bold fs-5">
                            <i class="uil uil-map"></i> Crear direccion del cliente
                        </h2>
                    </div>

                    <main className="dashboard-login-sp ">
                        <div className='container login-container'>


                            <div className='row align-items-center'>
                                <div className="col-12 col-md-12 col-lg-12 col-xl-12 justify-content-center align-items-lg-center order-xxl-1 order-0">
                                    <div className="border-0 rounded-4">
                                        <div className=" p-0">
                                            <div className=' mt-lg-4'>
                                                <section className="bg-white">
                                                    <div className="d-flex justify-content-center  justify-content-lg-center">
                                                    </div>
                                                    <div>
                                                        <div className=' pb-4'>
                                                            <div className="mt-1">
                                                                <label className='form-label fw-bold text-black'>Selecciona la ubicacion </label>
                                                                <Maps modo="puntear-geolocator" position={setCoordinates} onClickCoordenada={coords => setCoordinates(coords)} zoom={18} width={"100%"} height={"500px"} />
                                                            </div>

                                                            <div className='row d-flex '>
                                                                <div className="col-md-6 mt-2">
                                                                    <label className="form-label fw-bold text-black">
                                                                        <i class="uil uil-estate"></i> Direccion
                                                                    </label>
                                                                    <input
                                                                        type={'text'}
                                                                        className="form-control rounded-3 border-1 text-muted"
                                                                        id="text"
                                                                        name='pass'
                                                                        placeholder="Ingresar usuario"
                                                                        required
                                                                        spellcheck="false" onChange={(e) => setNameDirection(e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mt-1">
                                                                    <label className="form-label fw-bold text-black">
                                                                        <i class="uil uil-clinic-medical"></i> Num de casa o apartamento
                                                                    </label>
                                                                    <input
                                                                        type={'text'}
                                                                        className="form-control rounded-3 border-1 text-muted"
                                                                        id="text"
                                                                        name='pass'
                                                                        placeholder="#45"
                                                                        required
                                                                        spellcheck="false" onChange={(e) => setNumberHouse(e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mt-1">
                                                                    <label className="form-label fw-bold text-black">
                                                                        <i class="uil uil-phone"></i> Numero de telefono de direccion
                                                                    </label>
                                                                    
                                                                    <PhoneInput
                                                                        country={'pa'} 
                                                                        value={phone}
                                                                        onChange={phone => (setPhone(phone))}
                                                                        inputProps={{
                                                                            name: 'phone',
                                                                            required: true,
                                                                            autoFocus: true
                                                                        }}
                                                                        countryCodeEditable={false}
                                                                        enableSearch
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mt-1">
                                                                    <label className="form-label fw-bold text-black">
                                                                        <i class="uil uil-comment-notes"></i> Notas adicionales o referencias
                                                                    </label>
                                                                    <input
                                                                        type={'text'}
                                                                        className="form-control rounded-3 border-1 text-muted"
                                                                        id="text"
                                                                        name='pass'
                                                                        placeholder="Notas o referencias de la ubicacion"
                                                                        required
                                                                        spellcheck="false" onChange={(e) => setadditional_info(e.target.value)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className='d-flex justify-content-between'>
                                                            <button className='btn bg-danger-subtle text-danger  border-0 fw-bold ' onClick={() => (cleanInputs())}>
                                                                <i class="uil uil-times-circle"></i> Cancelar
                                                            </button>
                                                            <button className='btn bg-success-subtle text-success  border-0 fw-bold ' onClick={() => createAddressClient()} >
                                                                <i class="uil uil-save"></i> Guardar
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <footer >
                                                        <div className='container d-lg-flex justify-content-between align-content-center align-items-center w-100 text-center text-secondary'>
                                                            <div className=''>
                                                                <small className='opacity-50'>
                                                                    <i class="uil uil-copyright"></i> 2025 Smart Pay
                                                                </small>
                                                            </div>
                                                            <div>

                                                                <small className='opacity-50'>
                                                                    <i class="uil uil-bolt"></i> Powered by Smart Retail Group
                                                                </small>
                                                            </div>
                                                        </div>

                                                    </footer>
                                                </section>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>



                </Modal.Body >
            </Modal >

        </>
    )
}

export default ModalCreateAddressClient